export default __webpack_public_path__ + "static/media/image_18.9878ade1.png";